import { clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
    return twMerge(clsx(inputs))
}

/**
 * Formats a number as a currency string with comma separators.
 * @param {number} amount - The number to format.
 * @returns {string} The formatted currency string (e.g., "$1,250,000").
 */
export function formatPrice(amount) {
    if (typeof amount !== 'number') {
        return '$0';
    }
    // Check if it has decimals
    if (amount % 1 !== 0) {
        return `$${amount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
    }
    return `$${amount.toLocaleString('en-US')}`;
}

/**
 * Converts square meters to square varas.
 * 1 vara² ≈ 0.698896 m²
 * @param {number} meters - The area in square meters.
 * @returns {number} The area in square varas.
 */
export function convertToVaras(meters) {
    if (typeof meters !== 'number' || meters < 0) return 0;
    return meters / 0.698896;
}

/**
 * Converts square varas to square meters.
 * @param {number} varas - The area in square varas.
 * @returns {number} The area in square meters.
 */
export function convertToMeters(varas) {
    if (typeof varas !== 'number' || varas < 0) return 0;
    return varas * 0.698896;
}

/**
 * Formats an area in square meters to a string showing both m² and varas².
 * @param {number} meters - The area in square meters.
 * @returns {string} The formatted area string (e.g., "850 m² (1,214 v²)").
 */
export function formatArea(meters) {
    if (typeof meters !== 'number' || meters < 0) {
        return '0 m² (0 v²)';
    }
    const varas = convertToVaras(meters);
    return `${meters.toLocaleString('en-US')} m² (${varas.toLocaleString('en-US', { maximumFractionDigits: 0 })} v²)`;
}
